<template>
    <div class="card-form">
        <div
            v-if="showHeader"
            class="card-form__header"
        >
            <c-title :text="localIsNew ? $t(labelCreate) : $t(labelEdit)"></c-title>
            <!--<v-btn
                    color="primary"
                    @click="submit()"
                    :disabled="localSubmitLoading"
                    :loading="localSubmitLoading"
                    small
            >{{ localIsNew ? $t('msg.toCreate') : $t('msg.save') }}</v-btn>-->
        </div>
        <v-progress-linear
                v-if="localModelLoading"
                :indeterminate="true"
        ></v-progress-linear>
        <v-form v-if="!localModelLoading">
            <slot></slot>
        </v-form>
        <div
                v-if="!localModelLoading && !dontShowBtns"
                class="card-form__bottom"
        >
            <slot name="before-btn"></slot>
            <c-btn
                @click="submit(true)"
                color="primary"
                :disabled="localSubmitLoading"
                :loading="localSubmitLoading"
            >{{ localIsNew ? $t('msg.toCreate') : $t('msg.save') }}</c-btn>
            <c-btn
                v-if="localIsNew && labelCreateAndNext"
                @click="submit(true)"
                color="primary"
                :disabled="localSubmitLoading"
                :loading="localSubmitLoading"
            >{{ $t(labelCreateAndNext) }}</c-btn>
        </div>
    </div>
</template>

<script>
    import CTitle from "./CTitle";
    import CBtn from "./CBtn";

    export default {
        components: {CTitle, CBtn},
        props: {
            model: Object,
            validator: null,
            formErrors: Object,
            routeEdit: String,
            actionLoad: String,
            actionCreate: String,
            actionEdit: String,
            successRoute: String,
            id: undefined,
            subId: undefined,
            isNew: undefined,
            submitLoading: null,
            modelLoading: null,
            labelCreate: {type: String, default: 'msg.create'},
            labelEdit: {type: String, default: 'msg.edit'},
            labelCreateAndNext: null,
            routeCreateAndNext: {type: Function, default: null},
            beforeSubmit: {type: Function, default: null},
            showHeader: {type: Boolean, default: true},
            dontLoadModel: {type: Boolean, default: false},
            dontShowBtns: {type: Boolean, default: false}
        },
        data() {
            return {
                localSubmitLoading: this.submitLoading,
                localModelLoading: this.modelLoading,
                localIsNew: this.isNew,
                localId: this.id,
                localSubId: this.subId,
            }
        },
        watch: {
            isNew(v) {
                this.localIsNew = v;
            },
            localIsNew(v) {
                this.$emit('update:isNew', v)
            },
            id(v) {
                this.localId = v;
            },
            localId(v) {
                this.$emit('update:id', v)
            },
            subId(v) {
                this.localSubId = v;
                if (!this.localIsNew && this.localSubId !== null) this.loadModel();
            },
            localSubId(v) {
                this.$emit('update:subId', v)
            },
            submitLoading(v) {
                this.localSubmitLoading = v;
            },
            localSubmitLoading(v) {
                this.$emit('update:submitLoading', v)
            },
            modelLoading(v) {
                this.localSubmitLoading = v;
            },
            localModelLoading(v) {
                this.$emit('update:modelLoading', v)
            },
        },
        methods: {
            submit(nextStep) {
                this.validator.validateAll()
                    .then(res => {
                        if (res) {

                            this.localSubmitLoading = true;

                            const action = this.localIsNew ? this.actionCreate : this.actionEdit;
                            this.model.id = this.localIsNew ? null : this.model.id;

                            let model = Object.assign({}, this.model);

                            if (this.beforeSubmit !== null) this.beforeSubmit(model);

                            this.$store.dispatch(action, {
                                data: model,
                                id: this.localId,
                                subId: this.localSubId,
                                formErrors: this.formErrors
                            })
                                .then(res => {
                                    if (this.localIsNew) {
                                        this.$emit('created');
                                    } else {
                                        this.$emit('updated');
                                    }
                                    if (this.successRoute !== undefined) {
                                        if (nextStep && this.localIsNew && this.routeCreateAndNext) {
                                            this.$router.push(this.routeCreateAndNext({id: this.localId, subId: this.localSubId, newId: res.id}));
                                        } else {
                                            this.$router.push({name: this.successRoute});
                                        }
                                    }
                                    this.$emit('submitted');
                                })
                                .catch(() => this.scrollToError(this.formErrors))
                                .finally(() => this.localSubmitLoading = false);
                        } else {
                            this.scrollToError(this.formErrors);
                        }
                    });
            },
            loadModel() {
                if (this.dontLoadModel) return;

                if (this.localModelLoading) return;
                this.localModelLoading = true;

                this.$store.dispatch(this.actionLoad, {
                    id: this.localId,
                    subId: this.localSubId
                })
                    .then(res => {
                        this.$emit('update:model', res);
                        this.$emit('loaded', res)
                    })
                    .finally(() => this.localModelLoading = false);
            },
        },
        created() {
            if (this.localIsNew === undefined) this.localIsNew = this.$route.name !== this.routeEdit;

            if (this.localId === undefined) this.localId = this.$route.params.id;

            if (this.localSubId === undefined) this.localSubId = this.$route.params.sub_id;

            if (!this.localIsNew) {
                this.loadModel();
            }
        }
    }
</script>

<style lang="scss">
    .card-form {
        &.card-form_max-xs {
            max-width: 600px;
        }
        &.card-form_max-sm {
            max-width: 960px;
        }
        &.card-form_max-md {
            max-width: 1264px;
        }
        &.card-form_max-lg {
            max-width: 1904px;
        }
        .card-form__header {
            //border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            //margin-bottom: 15px;
        }
        .card-form__bottom {
            width: calc(100% + 10px);
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
            padding-top: 15px;
            padding-bottom: 5px;
            margin-left: -5px;

            button {
                margin: 5px;
            }
        }
        .card-form__input {
            margin-top: 10px;

            &:first-child {
                margin-top: 0;
            }
            &.v-input {
                margin-top: 10px;

                &:first-child {
                    margin-top: 0;
                }
            }
        }
    }
</style>